/*******************************************************************************
 * dialogs.js - Dialog Visibility Handlers
 * 
 * These functions are called by Syncfusion dialog beforeOpen events
 ******************************************************************************/

import { ELEMENT_IDS, API_ENDPOINTS } from './constants.js';
import { showDialog, hideDialog, getElement } from './utils.js';

// Re-export showDialog and hideDialog for direct use
export { showDialog, hideDialog };

/**
 * Before open handler for More Info ABA dialog
 */
export function promptContainerMoreInfoForABABeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_CONTAINER_MORE_INFO_ABA);
}

/**
 * Before open handler for main dialog container
 */
export function dlgContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.DLG_CONTAINER);
}

/**
 * Before open handler for error list dialog
 */
export function dlgViewErrorListBeforeOpen() {
    showDialog(ELEMENT_IDS.DLG_VIEW_ERROR_LIST);
}

/**
 * Before open handler for feedback modal
 */
export function dlgFeedbackModalBeforeOpen() {
    showDialog(ELEMENT_IDS.DLG_FEEDBACK_MODAL);
}

/**
 * Before open handler for mark as paid confirmation
 */
export function dlgMarkAsPaidConfirmationBeforeOpen() {
    showDialog(ELEMENT_IDS.DLG_MARK_PAID_CONFIRMATION);
}

/**
 * Before open handler for mark as paid error list
 */
export function dlgMarkAsPaidViewErrorListBeforeOpen() {
    showDialog(ELEMENT_IDS.DLG_MARK_PAID_ERROR_LIST);
}

/**
 * Before open handler for prompt dialog container
 */
export function promptDlgContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_DLG_CONTAINER);
}

/**
 * Before open handler for report prompt dialog
 */
export function promptDlgContainerReportBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_DLG_CONTAINER_REPORT);
}

/**
 * Before open handler for mark as paid prompt
 */
export function promptContainerForMarkAsPaidBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_CONTAINER_MARK_PAID);
}

/**
 * Before open handler for prompt container
 */
export function promptContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_CONTAINER);
}

/**
 * Before open handler for prompt container 1
 */
export function promptContainerBeforeOpen1() {
    showDialog(ELEMENT_IDS.PROMPT_CONTAINER1);
}

/**
 * Before open handler for expire subscriptions
 */
export function promptContainerExpireSubscriptionsBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_CONTAINER_EXPIRE_SUBS);
}

/**
 * Before open handler for welcome subscriptions
 */
export function promptContainerWelcomeSubscriptionsBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_CONTAINER_WELCOME_SUBS);
}

/**
 * Before open handler for activate subscriptions
 * Resets validation state when modal opens
 */
export function promptContainerActivateSubscriptionsBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_CONTAINER_ACTIVATE_SUBS);
    
    // Reset validation state when modal opens
    var feedbackDesc1El = document.getElementById("feedbackDesc1");
    if (feedbackDesc1El) feedbackDesc1El.style.visibility = "hidden";
    
    // Reset border colors on profile fields
    var profileFields = ["profileFirstName", "profileSurname", "profileJobTitle", "profileCompany"];
    profileFields.forEach(function(fieldId) {
        var el = document.getElementById(fieldId);
        if (el) el.style.borderColor = "#ddd9d9";
    });
}

/**
 * Before open handler for ABA prompt container
 */
export function promptContainerForABABeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_CONTAINER_ABA);
}

export function sharedExportContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.SHARED_EXPORT_CONTAINER);
}

export function sharedExportABAContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.SHARED_EXPORT_ABA_CONTAINER);
}

export function sharedErrorListContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.SHARED_ERROR_LIST_CONTAINER);
}

/**
 * Before open handler for progress dialog
 */
export function promptDlgProgressContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_DLG_PROGRESS_CONTAINER);
}

/**
 * Before open handler for report progress dialog
 */
export function promptDlgProgressContainerReportBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_DLG_PROGRESS_CONTAINER_REPORT);
}

/**
 * Before open handler for transaction date dialog
 */
export function promptDlgContainerTransactionDateBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_DLG_CONTAINER_TX_DATE);
}

/**
 * Before open handler for after export dialog
 */
export function dlgContainerAfterExportBeforeOpen() {
    showDialog(ELEMENT_IDS.DLG_CONTAINER_AFTER_EXPORT);
}

/**
 * Before open handler for update reference dialog
 */
export function promptDlgContainerUpdateRefBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_DLG_CONTAINER_UPDATE_REF);
}

/**
 * Before open handler for sending remittance progress
 */
export function promptDlgContainerSendingRemittanceProgressBeforeOpen() {
    showDialog(ELEMENT_IDS.PROMPT_DLG_SENDING_REMITTANCE_PROGRESS);
}

/**
 * Before open handler for error dialog
 */
export function errorDlgContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.ERROR_DLG_CONTAINER);
}

/**
 * Before open handler for transaction date 2 dialog
 */
export function promptDlgContainerTransactionDate2() {
    showDialog(ELEMENT_IDS.PROMPT_DLG_CONTAINER_TX_DATE2);
}

/**
 * Get Syncfusion dialog instance by ID
 * @param {string} id - Dialog element ID
 * @returns {object|null} - Dialog instance
 */
export function getDialogInstance(id) {
    var el = getElement(id);
    return el && el.ej2_instances ? el.ej2_instances[0] : null;
}

/**
 * Before open handler for missing data dialog
 */
export function missingDataDlgContainerBeforeOpen() {
    showDialog(ELEMENT_IDS.MISSING_DATA_DLG_CONTAINER);
}

/**
 * Show a user-friendly token expiration dialog
 * @param {string} title - Dialog title
 * @param {string} message - User-friendly message
 */
function showTokenExpiredDialog(title, message) {
    var existingOverlay = document.getElementById('tokenExpiredOverlay');
    if (existingOverlay) {
        existingOverlay.remove();
    }
    
    var overlay = document.createElement('div');
    overlay.id = 'tokenExpiredOverlay';
    overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 10000; display: flex; align-items: center; justify-content: center;';
    
    var dialog = document.createElement('div');
    dialog.style.cssText = 'background: white; border-radius: 12px; padding: 32px; max-width: 450px; width: 90%; box-shadow: 0 10px 40px rgba(0,0,0,0.2); text-align: center;';
    
    dialog.innerHTML = `
        <div style="margin-bottom: 20px;">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
        </div>
        <h3 style="margin: 0 0 16px 0; font-size: 20px; color: #1f2937; font-weight: 600;">${title || 'Your Xero connection has expired'}</h3>
        <p style="margin: 0 0 24px 0; color: #6b7280; font-size: 15px; line-height: 1.6;">${message || 'For security reasons, your connection to Xero needs to be refreshed periodically. This is normal and your data is safe.'}</p>
        <div style="display: flex; gap: 12px; justify-content: center;">
            <button id="tokenExpiredReconnectBtn" style="background: #0d6efd; color: white; border: none; padding: 12px 24px; border-radius: 8px; font-size: 15px; font-weight: 500; cursor: pointer; transition: background 0.2s;">
                Reconnect to Xero
            </button>
            <button id="tokenExpiredCancelBtn" style="background: #f3f4f6; color: #374151; border: none; padding: 12px 24px; border-radius: 8px; font-size: 15px; font-weight: 500; cursor: pointer; transition: background 0.2s;">
                Cancel
            </button>
        </div>
    `;
    
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    
    document.getElementById('tokenExpiredReconnectBtn').addEventListener('click', function() {
        // Detect browser for Authorization route
        let userAgent = navigator.userAgent;
        let browser = "";
        if (userAgent.match(/edg/i)) {
            browser = "edge";
        } else if (userAgent.match(/firefox|fxios/i)) {
            browser = "firefox";
        } else if (userAgent.match(/opr\//i)) {
            browser = "opera";
        } else if (userAgent.match(/chrome|chromium|crios/i)) {
            browser = "chrome";
        } else if (userAgent.match(/safari/i)) {
            browser = "safari";
        } else {
            browser = "other";
        }
        window.location.href = `/Authorization/Index/${browser}`;
    });
    
    document.getElementById('tokenExpiredCancelBtn').addEventListener('click', function() {
        overlay.remove();
    });
    
    overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
            overlay.remove();
        }
    });
}

window.showTokenExpiredDialog = showTokenExpiredDialog;

/**
 * Show error message in the missing data modal
 * @param {string} message - Error message to display
 */
function showMissingDataError(message) {
    var errorBox = document.getElementById(ELEMENT_IDS.MISSING_DATA_ERROR_BOX);
    var errorMessage = document.getElementById(ELEMENT_IDS.MISSING_DATA_ERROR_MESSAGE);
    
    if (errorBox && errorMessage) {
        errorMessage.textContent = message;
        errorBox.style.display = 'block';
    }
}

/**
 * Hide error message in the missing data modal
 */
function hideMissingDataError() {
    var errorBox = document.getElementById(ELEMENT_IDS.MISSING_DATA_ERROR_BOX);
    if (errorBox) {
        errorBox.style.display = 'none';
    }
}

/**
 * Update Save button state based on field values
 * Only checks visible fields (sections that are displayed)
 */
function updateMissingDataSaveButtonState() {
    var emailInput = document.getElementById(ELEMENT_IDS.MISSING_DATA_EMAIL);
    var bankInput = document.getElementById(ELEMENT_IDS.MISSING_DATA_BANK_ACCOUNT_NUMBER);
    var saveBtn = document.getElementById(ELEMENT_IDS.BTN_MISSING_DATA_SAVE);
    var emailSection = document.getElementById('missingDataEmailSection');
    var bankSection = document.getElementById('missingDataBankSection');
    
    if (!saveBtn) return;
    
    // Only check visible fields
    var emailVisible = emailSection && emailSection.style.display !== 'none';
    var bankVisible = bankSection && bankSection.style.display !== 'none';
    
    var emailValue = (emailVisible && emailInput) ? emailInput.value.trim() : '';
    var bankValue = (bankVisible && bankInput) ? bankInput.value.trim() : '';
    
    var hasAnyValue = emailValue.length > 0 || bankValue.length > 0;
    saveBtn.disabled = !hasAnyValue;
    
    // Apply visual styling for disabled/enabled states
    if (hasAnyValue) {
        saveBtn.style.backgroundColor = '#0d6efd';
        saveBtn.style.opacity = '1';
        saveBtn.style.cursor = 'pointer';
    } else {
        saveBtn.style.backgroundColor = '#9ca3af';
        saveBtn.style.opacity = '0.65';
        saveBtn.style.cursor = 'not-allowed';
    }
}

/**
 * Open the missing data modal with bill information
 * @param {object} billData - The bill data containing contact and missing info
 */
export function openMissingDataModal(billData) {
    var dialogEl = getElement(ELEMENT_IDS.MISSING_DATA_DIALOG);
    if (!dialogEl || !dialogEl.ej2_instances) {
        console.error('Missing data dialog not found');
        return;
    }
    
    var dialog = dialogEl.ej2_instances[0];
    
    window.currentMissingDataBill = billData;
    
    var contactNameEl = document.getElementById(ELEMENT_IDS.MISSING_DATA_CONTACT_NAME);
    if (contactNameEl) {
        contactNameEl.textContent = billData.contactName || billData.contact?.name || 'Unknown Contact';
    }
    
    var emailSection = document.getElementById('missingDataEmailSection');
    var bankSection = document.getElementById('missingDataBankSection');
    
    if (emailSection) {
        emailSection.style.display = billData.hasEmailAddress ? 'none' : 'block';
    }
    if (bankSection) {
        bankSection.style.display = billData.hasBankDetails ? 'none' : 'block';
    }
    
    var emailInput = document.getElementById(ELEMENT_IDS.MISSING_DATA_EMAIL);
    if (emailInput) emailInput.value = billData.emailAddress || '';
    
    var bankAccountNumberInput = document.getElementById(ELEMENT_IDS.MISSING_DATA_BANK_ACCOUNT_NUMBER);
    if (bankAccountNumberInput) bankAccountNumberInput.value = '';
    
    // Hide any previous error messages
    hideMissingDataError();
    
    showDialog(ELEMENT_IDS.MISSING_DATA_DLG_CONTAINER);
    dialog.show();
    
    // Setup button handlers after dialog is shown (handles Syncfusion dynamic rendering)
    setTimeout(function() {
        var saveBtn = document.getElementById(ELEMENT_IDS.BTN_MISSING_DATA_SAVE);
        var cancelBtn = document.getElementById(ELEMENT_IDS.BTN_MISSING_DATA_CANCEL);
        var emailInput = document.getElementById(ELEMENT_IDS.MISSING_DATA_EMAIL);
        var bankInput = document.getElementById(ELEMENT_IDS.MISSING_DATA_BANK_ACCOUNT_NUMBER);
        
        if (saveBtn && !saveBtn._handlerAttached) {
            saveBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                saveMissingData();
            });
            saveBtn._handlerAttached = true;
        }
        
        if (cancelBtn && !cancelBtn._handlerAttached) {
            cancelBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                closeMissingDataModal();
            });
            cancelBtn._handlerAttached = true;
        }
        
        // Add input listeners to update Save button state
        if (emailInput && !emailInput._inputHandlerAttached) {
            emailInput.addEventListener('input', updateMissingDataSaveButtonState);
            emailInput._inputHandlerAttached = true;
        }
        if (bankInput && !bankInput._inputHandlerAttached) {
            bankInput.addEventListener('input', updateMissingDataSaveButtonState);
            bankInput._inputHandlerAttached = true;
        }
        
        // Set initial button state (disabled if no values)
        updateMissingDataSaveButtonState();
    }, 100);
}

/**
 * Close the missing data modal
 */
export function closeMissingDataModal() {
    var dialogEl = getElement(ELEMENT_IDS.MISSING_DATA_DIALOG);
    if (dialogEl && dialogEl.ej2_instances) {
        dialogEl.ej2_instances[0].hide();
    }
    window.currentMissingDataBill = null;
}

// Guard to prevent duplicate save submissions
var isSavingMissingData = false;

/**
 * Handle save button click on missing data modal
 */
export async function saveMissingData() {
    // Prevent duplicate submissions
    if (isSavingMissingData) {
        console.log('Save already in progress, ignoring duplicate click');
        return;
    }
    
    var billData = window.currentMissingDataBill;
    if (!billData) {
        console.error('No bill data found');
        return;
    }
    
    var email = document.getElementById(ELEMENT_IDS.MISSING_DATA_EMAIL)?.value || '';
    var bankAccountDetails = document.getElementById(ELEMENT_IDS.MISSING_DATA_BANK_ACCOUNT_NUMBER)?.value || '';
    
    if (!email && !bankAccountDetails) {
        showMissingDataError('Please enter at least an email address or bank account number.');
        return;
    }
    
    var requestData = {
        contactId: billData.contact?.contactID,
        email: email,
        bankAccountDetails: bankAccountDetails
    };
    
    var saveBtn = document.getElementById(ELEMENT_IDS.BTN_MISSING_DATA_SAVE);
    var cancelBtn = document.getElementById(ELEMENT_IDS.BTN_MISSING_DATA_CANCEL);
    
    // Set guard flag to prevent duplicate submissions
    isSavingMissingData = true;
    
    if (saveBtn) {
        saveBtn.disabled = true;
        saveBtn.innerHTML = 'Saving... <img src="/img/loading-indicator1.gif" alt="loading" style="height:15px; margin-left:5px;">';
    }
    if (cancelBtn) cancelBtn.disabled = true;
    
    try {
        var response = await fetch(API_ENDPOINTS.UPDATE_CONTACT_DETAILS, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        });
        
        var result = await response.json();
        
        if (result.isError) {
            if (result.tokenExpired) {
                closeMissingDataModal();
                showTokenExpiredDialog(result.tokenExpiredTitle, result.tokenExpiredMessage);
            } else {
                showMissingDataError(result.message);
            }
        } else {
            hideMissingDataError();
            closeMissingDataModal();
            
            if (typeof window.refreshClick === 'function') {
                window.refreshClick();
            } else if (typeof window.operations !== 'undefined' && typeof window.operations.onGetBills === 'function') {
                window.operations.onGetBills();
            }
        }
    } catch (error) {
        console.error('Error saving missing data:', error);
        showMissingDataError('An error occurred while saving. Please try again.');
    } finally {
        // Reset guard flag
        isSavingMissingData = false;
        
        if (saveBtn) {
            saveBtn.disabled = false;
            saveBtn.innerHTML = 'Save';
        }
        if (cancelBtn) cancelBtn.disabled = false;
        
        // Re-check button state after save completes
        updateMissingDataSaveButtonState();
    }
}

window.openMissingDataModal = openMissingDataModal;
window.closeMissingDataModal = closeMissingDataModal;
window.saveMissingData = saveMissingData;
window.missingDataDlgContainerBeforeOpen = missingDataDlgContainerBeforeOpen;

/**
 * Setup event listeners for missing data modal buttons
 * This is called after DOM is ready to ensure buttons exist
 */
function setupMissingDataButtonHandlers() {
    var saveBtn = document.getElementById(ELEMENT_IDS.BTN_MISSING_DATA_SAVE);
    var cancelBtn = document.getElementById(ELEMENT_IDS.BTN_MISSING_DATA_CANCEL);
    
    if (saveBtn) {
        saveBtn.removeEventListener('click', saveMissingData);
        saveBtn.addEventListener('click', saveMissingData);
    }
    
    if (cancelBtn) {
        cancelBtn.removeEventListener('click', closeMissingDataModal);
        cancelBtn.addEventListener('click', closeMissingDataModal);
    }
}

// Setup button handlers when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMissingDataButtonHandlers);
} else {
    setupMissingDataButtonHandlers();
}

// Also setup handlers after a short delay to handle Syncfusion dynamic rendering
setTimeout(setupMissingDataButtonHandlers, 500);
setTimeout(setupMissingDataButtonHandlers, 1500);
